// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"6760d7fa","787":"3c0ed9bf"}[chunkId] + ".chunk.js";
};